// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 22 22", width: "22", height: "22" }, props),
        React.createElement("path", { d: "M14.1806 12.3472C14.449 12.0787 14.8843 12.0787 15.1528 12.3472C15.4213 12.6157 15.4213 13.051 15.1528 13.3195L11.4862 16.9861C11.2177 17.2546 10.7824 17.2546 10.5139 16.9861L6.84722 13.3195C6.57873 13.051 6.57873 12.6157 6.84722 12.3472C7.1157 12.0787 7.551 12.0787 7.81949 12.3472L10.3125 14.8402L10.3125 5.95833C10.3125 5.57864 10.6203 5.27083 11 5.27083C11.3797 5.27083 11.6875 5.57864 11.6875 5.95833L11.6875 14.8402L14.1806 12.3472Z" })));
};
Icon.displayName = 'ArrowDown22x22';
export default Icon;
//# sourceMappingURL=ArrowDown22x22.js.map